<wl-info-card
  class="d-block mt-2"
  [type]="'danger'"
  [title]="{ value: errorTitle() }"
  [message]="{ value: errorMessage() }"
  [border]="true"
  [shadow]="false"
></wl-info-card>
